import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { select, takeLatest, call } from 'redux-saga/effects';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { loadDuperbrowseItem } from '../../Duperbrowse/redux/actionCreators';
import { getLoadCount } from '../../Duperbrowse/redux/selectors';
import { getDuperRedirectThreshold } from './selectors';
const logger = ddt.createLogger('sisufunnel');
function* handleLoading({ payload: { itemSchema } }) {
    if (itemSchema !== 'deviation') {
        return;
    }
    const loadCount = yield select(getLoadCount);
    logger.log('Duperbrowse load count: ', loadCount);
    const threshold = yield select(getDuperRedirectThreshold);
    // Noop because BI still looking into signup data
    if (1 === 1) {
        return;
    }
    if (loadCount > threshold) {
        const data = {
            evid: BiEventType.REDIRECT_TO_LOGIN,
            referral_info: ReferralType.SISU_FUNNEL_NEXT_DEVIATION
        };
        yield call(logBiEvent, data);
        window.location.assign(Url.joinLink());
    }
}
export function* sisuFunnelSaga() {
    const loggedIn = yield select(getIsLoggedIn);
    if (loggedIn) {
        return;
    }
    yield takeLatest(loadDuperbrowseItem, handleLoading);
}
